import getRemBase from 'propel/getRemBase';
import throttle from 'lodash/throttle';

require('dom-slider');

const { slideUp, slideToggle } = window.domSlider;

const blocks = document.querySelectorAll('.block-tab-vertical');

blocks.forEach((block) => {
	const tabButtons = block.querySelectorAll(
		'.block-tab-vertical-tab__button'
	);

	block.classList.remove('block-tab-vertical--uninitalized');

	const toggleTab = (e) => {
		e.preventDefault();

		const button = e.currentTarget;
		let activeSlideFound = false;

		if (
			button?.parentElement?.classList.contains(
				'block-tab-vertical-tab--active'
			)
		) {
			return;
		}

		tabButtons.forEach((tabButton, index) => {
			if (tabButton === button) {
				tabButton.parentElement.classList.add(
					'block-tab-vertical-tab--active'
				);

				block.setAttribute('data-active-tab', index);

				activeSlideFound = true;

				if (window.innerWidth < 768) {
					slideToggle({
						element: tabButton.nextElementSibling,
						slideSpeed: 400,
						easing: 'ease-in-out',
					});
				}
			} else {
				tabButton.parentElement.classList.remove(
					'block-tab-vertical-tab--active'
				);

				if (window.innerWidth < 768) {
					slideUp({
						element: tabButton.nextElementSibling,
						slideSpeed: 400,
						easing: 'ease-in-out',
					});
				} else {
					tabButton.nextElementSibling.style.removeProperty(
						'display'
					);
				}
			}

			if (!activeSlideFound) {
				tabButton.parentElement.classList.add(
					'block-tab-vertical-tab--offset'
				);
			} else {
				tabButton.parentElement.classList.remove(
					'block-tab-vertical-tab--offset'
				);
			}
		});
	};

	tabButtons.forEach((button) => {
		button.addEventListener('click', toggleTab);
	});
});

const setSlideContentWidth = () => {
	const remBase = getRemBase();
	const contentBlocks = document.querySelectorAll(
		'.block-tab-vertical-tab__content'
	);

	contentBlocks.forEach((contentBlock, index) => {
		const thisBlock = contentBlock.closest('.block-tab-vertical');
		const activeTabIndex = parseInt(thisBlock?.dataset?.activeTab ?? 0);

		if (window.innerWidth < 768) {
			if (activeTabIndex === index) {
				return;
			}

			contentBlock.classList.add('DOM-slider-hidden');
			contentBlock.setAttribute('aria-hidden', 'true');
		} else {
			contentBlock.classList.remove('DOM-slider-hidden');
			contentBlock.removeAttribute('aria-hidden');
		}
	});

	blocks.forEach((block) => {
		block.style.removeProperty('--activeTabContentWidth');

		let activeTabContent = block.querySelector(
			'.block-tab-vertical-tab--active .block-tab-vertical-tab__content'
		);

		const firstTabContent = block.querySelector(
			'.block-tab-vertical-tab .block-tab-vertical-tab__content'
		);

		if (!activeTabContent) {
			activeTabContent = firstTabContent;

			activeTabContent?.parentElement?.classList.add(
				'block-tab-vertical-tab--active'
			);
		}

		if (!activeTabContent) {
			return;
		}

		block.style.setProperty(
			'--activeTabContentWidth',
			`${firstTabContent.offsetWidth / remBase}rem`
		);
	});
};

setSlideContentWidth();

window.addEventListener('resize', throttle(setSlideContentWidth, 100));
